import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const request = axios.create({
  baseURL: '/api/admin',
  timeout: 15000
})

// 请求拦截器：自动附加 token
function cleanParams(params) {
  if (!params || params instanceof URLSearchParams) return params
  const cleaned = {}
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value === undefined || value === null || value === '') return
    if (value === 'undefined' || value === 'null') return
    cleaned[key] = value
  })
  return cleaned
}

request.interceptors.request.use(config => {
  config.params = cleanParams(config.params)
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// 响应拦截器：统一处理错误
request.interceptors.response.use(
  response => {
    // blob 下载直接返回原始响应
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code === 0) {
      return res.data
    }
    Message.error(res.message || '请求失败')
    return Promise.reject(new Error(res.message || '请求失败'))
  },
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        Message.warning('登录已过期，请重新登录')
        localStorage.removeItem('admin_token')
        localStorage.removeItem('admin_info')
        router.push('/login')
      } else if (status === 403) {
        Message.error('无权限访问')
      } else {
        Message.error((error.response.data && error.response.data.message) || '服务器错误')
      }
    } else {
      Message.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

export default request
